const oppOverview = [
  {
      "iso": "ET",
      "country": "South Africa",
      "project": 41,
      "career": 30,
      "employ": 25,
      "edu": 29,
      "econ": 17,
      "liva": 40,
      "total": 30,
      "rank": 1
  },
  {
      "iso": "NG",
      "country": "Mauritius",
      "project": 26,
      "career": 7,
      "employ": 25,
      "edu": 23,
      "econ": 56,
      "liva": 37,
      "total": 29,
      "rank": 2
  },
  {
      "iso": "CI",
      "country": "Egypt",
      "project": 24,
      "career": 14,
      "employ": 24,
      "edu": 33,
      "econ": 4,
      "liva": 34,
      "total": 22,
      "rank": 3
  },
  {
      "iso": "DZ",
      "country": "Morocco",
      "project": 24,
      "career": 2,
      "employ": 21,
      "edu": 19,
      "econ": 10,
      "liva": 38,
      "total": 19,
      "rank": 4
  },
  {
      "iso": "KE",
      "country": "Ghana",
      "project": 21,
      "career": 3,
      "employ": 12,
      "edu": 17,
      "econ": 4,
      "liva": 42,
      "total": 17,
      "rank": 5
  },
  {
      "iso": "NA",
      "country": "Algeria",
      "project": 22,
      "career": 5,
      "employ": 17,
      "edu": 15,
      "econ": 3,
      "liva": 36,
      "total": 16,
      "rank": 6
  },
  {
      "iso": "GH",
      "country": "Kenya",
      "project": 25,
      "career": 2,
      "employ": 11,
      "edu": 14,
      "econ": 6,
      "liva": 37,
      "total": 16,
      "rank": 6
  },
  {
      "iso": "MA",
      "country": "Namibia",
      "project": 23,
      "career": 4,
      "employ": 18,
      "edu": 13,
      "econ": 9,
      "liva": 28,
      "total": 16,
      "rank": 6
  },
  {
      "iso": "EG",
      "country": "Nigeria",
      "project": 22,
      "career": 9,
      "employ": 10,
      "edu": 12,
      "econ": 2,
      "liva": 28,
      "total": 14,
      "rank": 7
  },
  {
      "iso": "MU",
      "country": "Cote d'Ivoire",
      "project": 22,
      "career": 2,
      "employ": 13,
      "edu": 10,
      "econ": 3,
      "liva": 32,
      "total": 14,
      "rank": 7
  },
  {
      "iso": "ZA",
      "country": "Ethiopia",
      "project": 21,
      "career": 0,
      "employ": 6,
      "edu": 6,
      "econ": 3,
      "liva": 26,
      "total": 10,
      "rank": 8
  }
];

export {oppOverview};